
(function () {
let activeSliders = [];

function initSliders() {
  destroySliders(); 

  let sliders = document.querySelectorAll('.Blockquote-block-wrapper');

  sliders.forEach((slider) => {
    const enable_on_mob  = slider.dataset.enableMob === "true";
    const enable_on_desk = slider.dataset.enableDesk === "true";

    // const isMobile  = Responsive.matchesBreakpoint('phone') || Responsive.matchesBreakpoint('pocket');
    // const isDesktop = Responsive.matchesBreakpoint('lap-and-up');
    const isMobile  = window.innerWidth <= 998;
    const isDesktop = window.innerWidth > 998;


     const shouldPlay = (enable_on_mob && isMobile) ||(enable_on_desk && isDesktop) ||(enable_on_mob && enable_on_desk); 
    if (!shouldPlay) return;

    const gap = parseFloat(slider.dataset.gap) || 20;
    const slidesToShow = isMobile ? 1 : 4;

    let flkty = new Flickity(slider, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      cellSpacing: gap ,
      cssEase: 'linear',
      groupCells: slidesToShow,   
      contain: true, 
    });

    flkty.on('ready', function () {
      slider.classList.add('is-ready');
    });


    setTimeout(() => {
      slider.classList.add('is-ready');
    }, 300);


    let speed = parseFloat(slider.dataset.speed) || 1.5;
    flkty.x = 0;

    function play() {
      flkty.x -= speed;
      flkty.settle(flkty.x);
      flkty._tickerRAF = requestAnimationFrame(play);
    }

    play();

    slider._flickity = flkty;
    slider._tickerRAF = flkty._tickerRAF;
    activeSliders.push(slider);
  });
}

function destroySliders() {
  activeSliders.forEach((slider) => {
    if (slider._flickity) {
      cancelAnimationFrame(slider._tickerRAF);
      slider._flickity.destroy();
      slider._flickity = null;
    }
  });

  activeSliders = [];
}
domReady(() => {
  initSliders();
});
document.addEventListener('breakpoint:changed', () => {
  initSliders();
});
})();









